import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { asyncPopulateUsersAndThreadsAndCategories } from '../states/shared/actions';

import ThreadsList from '../components/ThreadsList';
import CategoriesList from '../components/CategoriesList';

const ThreadsPage = () => {
  const dispatch = useDispatch();
  const { threads = [], users = [], categories = {} } = useSelector((states) => states);

  React.useEffect(() => {
    dispatch(asyncPopulateUsersAndThreadsAndCategories());
  }, [dispatch]);

  const filteredThreads = threads.filter(
    (thread) => thread.category === categories.selectedCategory,
  );

  return (
    <>
      <CategoriesList categories={categories.values} />
      <ThreadsList
        threads={
        categories.selectedCategory ? filteredThreads : threads
        }
        users={users}
      />
    </>
  );
};
export default ThreadsPage;
